import type { IconData } from '@stacksjs/iconify-core'

export const shoppingCartAddSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.47 1.5H4.81c-1.7 0-3.225 1.242-3.296 3.015a17 17 0 0 0 0 1.37C1.585 7.658 3.11 8.9 4.81 8.9h3.097a504 504 0 0 1 2.25 8.267c1.14 4.284 2.254 8.476 3.656 12.962c.637 2.04 2.295 3.605 4.464 3.87c2.085.254 5.296.501 9.913.501c4.745 0 7.899-.26 9.872-.523c1.937-.258 3.445-1.61 4.077-3.421c1.492-4.277 2.817-9.513 3.684-14.41c.475-2.686-1.643-5.046-4.334-5.046H16.51l-1.79-5.739A5.5 5.5 0 0 0 9.47 1.5M35 22.5a2 2 0 0 0-2-2h-3v-3a2 2 0 1 0-4 0v3h-3a2 2 0 1 0 0 4h3v3a2 2 0 1 0 4 0v-3h3a2 2 0 0 0 2-2\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" d=\"M42.5 41.5a5 5 0 1 0-10 0a5 5 0 0 0 10 0m-24-5a5 5 0 1 1 0 10a5 5 0 0 1 0-10\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default shoppingCartAddSolid
